import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MotorKitsSkincareComponent } from './motor-kits-skincare.component';

const routes: Routes = [{ path: '', component: MotorKitsSkincareComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MotorKitsSkincareRoutingModule {}
